<template>
  <div
    id="updatePassword"
    :style="{ height: clientHeight + 'px' }"
    class="content self_c"
  >
    <headNav :back="true" title=" " :flag="true" />
    <div class="self_b">
      <div class="cell-content self-content">
        <p class="cell-title self_cell-title" slot="title">
          {{ window_c["Change password"] }}
        </p>
        <div class="self_cell-group_title self_cell-group_title_1">
          {{ formData.oldpwdText }}
        </div>
        <van-field
          class="self_cell-input"
          type="password"
          maxlength="20"
          v-model="form.oldpwd"
          center
          clearable
          :placeholder="formData.oldpwdPlaceholder"
        ></van-field>
        <div v-if="params.type == 2">
          <div class="self_cell-group_title">{{ formData.newpwdText }}</div>
          <van-field
            class="self_cell-input"
            type="password"
            maxlength="20"
            v-model="form.newpwd"
            center
            clearable
            :placeholder="formData.newpwdPlaceholder"
          ></van-field>
        </div>
        <p class="cell-p" slot="title">{{ formData.newpwdText_ }}</p>
        <van-field
          class="self_cell-input"
          type="password"
          maxlength="20"
          v-model="form.password"
          :placeholder="formData.newpwdPlaceholder_"
        ></van-field>
      </div>
      <div class="cell-button" style="margin-top: auto;margin-bottom: 15px;">
        <p
          @click="confirm"
          :style="
            !form.oldpwd ||
            (form.oldpwd && form.oldpwd.length < 6) ||
            (params.type == 2 &&
              (!form.newpwd || (form.newpwd && form.newpwd.length < 6))) ||
            !form.password ||
            (form.password && form.password.length < 6)
              ? 'background-color:#ccc;'
              : 'background-color:' + color_
          "
        >
          {{ window_c["confirm revision"] }}
        </p>
        <!-- <van-button color="#5abba7" @click="confirm" type="primary" size="large">完成</van-button> -->
      </div>
    </div>
  </div>
</template>
<script>
import headNav from "@/components/headNav";
import myfn from "@/js/util";
import { setPassword, setPassword2 } from "@/js/api";
import desUtil from "@/js/DesUtil";
import lang_ from "@/js/locales";
import util from "@/js/util";

export default {
  data() {
    return {
      window_c: {
        "Change password": "更改密碼",
        "confirm revision": "確認修改",
        "Please enter the password": "請輸入密碼",
        "Please enter a password of at least 6 digits":
          "請輸入至少6位数以上密碼",
        "Please enter the confirmation password": "請輸入確認密碼",
        "The two passwords are inconsistent": "兩次輸入的密碼不一致",
        "Password reset succeeded": "密碼重置成功",
        "Please enter the old password": "請輸入舊的密碼"
      },
      clientHeight: 603,
      form: {
        oldpwd: "",
        newpwd: "",
        password: ""
      },
      formData: {
        oldpwdText: "密碼",
        oldpwdPlaceholder: "請輸入密碼",
        newpwdText: "新密碼",
        newpwdPlaceholder: "請輸入新密碼",
        newpwdText_: "確認密碼",
        newpwdPlaceholder_: "請確認密碼"
      },
      params: {
        type: "1",
        phone: ""
      },
      color_: "",
      autoCode: "",
      countryId: ""
    };
  },
  created() {
    myfn.selfSetIcon(); // 設置logo
    myfn.getBrand(this, () => {
      this.color_ = this.themeColor;
    });
    var par = util
      .getQueryParams(this.$route.params)
      .splice(1)
      .join("_");
    console.log(par);
    var type = par.split("_")[1];
    this.autoCode = type;
    this.countryId = par.split("_")[2];
    if (type == 1) {
      var userinfo = myfn.userInfo.get(this, 1);
      if (!myfn.ISNULL(userinfo)) {
        this.$router.replace({
          name: "vipCard",
          params: util.setQueryParams([util.getBrandId(this, 1)])
        });
      }
    }
  },
  mounted() {
    sessionStorage.removeItem("myTime");
    this.init_lang();
    this.clientHeight = window.innerHeight || 603;
    var par = util
      .getQueryParams(this.$route.params)
      .splice(1)
      .join("_");
    this.params.phone = par.split("_")[0];
    this.params.type = par.split("_")[1];
    if (this.params.type == 2) {
      this.formData.oldpwdText = lang_.t("Old password");
      this.formData.oldpwdPlaceholder = lang_.t(
        "Please enter the old password"
      );
      this.formData.newpwdPlaceholder_ = lang_.t(
        "Please confirm the new password"
      );
    }
  },
  methods: {
    init_lang() {
      var window_c = this.window_c;
      window_c["Change password"] = lang_.t("Change password");
      window_c["confirm revision"] = lang_.t("confirm revision");
      window_c["Please enter the password"] = lang_.t(
        "Please enter the password"
      );
      window_c["Please enter a password of at least 6 digits"] = lang_.t(
        "Please enter a password of at least 6 digits"
      );
      window_c["Please enter the confirmation password"] = lang_.t(
        "Please enter the confirmation password"
      );
      window_c["The two passwords are inconsistent"] = lang_.t(
        "The two passwords are inconsistent"
      );
      window_c["Password reset succeeded"] = lang_.t(
        "Password reset succeeded"
      );
      window_c["Please enter the old password"] = lang_.t(
        "Please enter the old password"
      );
      this.formData.oldpwdText = lang_.t("Password");
      this.formData.oldpwdPlaceholder = lang_.t("Please enter a new password");
      this.formData.newpwdText = lang_.t("New password");
      this.formData.newpwdPlaceholder = lang_.t("Please enter a new password");
      this.formData.newpwdText_ = lang_.t("Confirm password");
      this.formData.newpwdPlaceholder_ = lang_.t(
        "Please confirm the new password"
      );
    },
    confirm() {
      var self = this;
      var form = this.form;
      if (
        !form.oldpwd ||
        (form.oldpwd && form.oldpwd.length < 6) ||
        (this.params.type == 2 &&
          (!form.newpwd || (form.newpwd && form.newpwd.length < 6))) ||
        !form.password ||
        (form.password && form.password.length < 6)
      ) {
        return;
      }

      if (this.params.type == 2) {
        this.confirm_();
        return;
      }
      if (!this.form.oldpwd) {
        this.$toast(self.window_c["Please enter the password"]);
      } else if (this.form.oldpwd && this.form.oldpwd.length < 6) {
        this.$toast(
          self.window_c["Please enter a password of at least 6 digits"]
        );
      } else if (!this.form.password) {
        this.$toast(self.window_c["Please enter the confirmation password"]);
      } else if (this.form.password && this.form.password.length < 6) {
        this.$toast(
          self.window_c["Please enter a password of at least 6 digits"]
        );
      } else if (this.form.password != this.form.oldpwd) {
        this.$toast(self.window_c["The two passwords are inconsistent"]);
      } else {
        let userInfo = myfn.userInfo.get(this, 1);
        userInfo = JSON.parse(userInfo);
        var data = {
          phone: self.params.phone,
          password: self.form.oldpwd,
          newPassword: self.form.password,
          code: this.autoCode,
          countryId: this.countryId
        };
        setPassword2(data).then(res => {
          if (res.success) {
            let brandId = util.getBrandId(this, 1);
            self.$toast({
              message: self.window_c["Password reset succeeded"],
              onClose: () => {
                self.$router.replace({
                  name: "login",
                  params: {
                    arg: util.setQueryParams([brandId])
                  }
                });
              }
            });
          } else {
            this.$toast(res.errMsg);
          }
        });
      }
    },
    confirm_() {
      var self = this;
      if (!this.form.oldpwd) {
        this.$toast(self.window_c["Please enter the old password"]);
      } else if (this.form.oldpwd && this.form.oldpwd.length < 6) {
        this.$toast(
          self.window_c["Please enter a password of at least 6 digits"]
        );
      } else if (!this.form.newpwd) {
        this.$toast(self.formData.newpwdPlaceholder);
      } else if (this.form.newpwd && this.form.newpwd.length < 6) {
        this.$toast(
          self.window_c["Please enter a password of at least 6 digits"]
        );
      } else if (!this.form.password) {
        this.$toast(self.window_c["Please enter the confirmation password"]);
      } else if (this.form.password != this.form.newpwd) {
        this.$toast(self.window_c["The two passwords are inconsistent"]);
      } else {
        let userInfo = myfn.userInfo.get(this, 1);
        userInfo = JSON.parse(userInfo);
        var data = {
          phone: self.params.phone,
          password: self.form.oldpwd,
          newPassword: self.form.password,
          id: userInfo.memberId
        };
        setPassword(data).then(res => {
          if (res.success) {
            self.$toast({
              message: self.window_c["Password reset succeeded"],
              onClose: () => {
                this.$router.back();
              }
            });
          } else {
            this.$toast(res.errMsg);
          }
        });
      }
    }
  },
  components: {
    headNav
  }
};
</script>

<style scoped>
#updatePassword .van-hairline--top-bottom:after,
#updatePassword .van-hairline-unset--top-bottom:after {
  border-width: 0;
}

#updataPassword .van-cell-group__title {
  color: #000;
  padding: 14px 16px 0px;
}

#updatePassword .van-cell__value,
#updatePassword .van-cell__value--alone {
  border-bottom: 1px solid #999;
  padding-bottom: 8px;
}
</style>

<style scoped>
#updatePassword {
  background: #fff;
  display: flex;
  flex-direction: column;
}

.cell-content {
  padding-top: 30px;
  margin-bottom: 260px;
}

.cell-title {
  font-size: 50px;
  color: #333;
  margin: 50px 0;
}

.cell-desc {
  font-size: 28px;
  color: #000;
}

.cell-icon {
  width: 50px;
  height: 50px;
  margin-top: 10px;
}

.cell-button p {
  width: calc(100% - 20px);
  height: 44px;
  line-height: 44px;
  text-align: center;
  background-color: #5abba7;
  color: #fff;
  border-radius: 8px;
  margin: 0 auto;
  font-size: 17px;
}

.cell-button p:active {
  opacity: 0.8;
}

.cell-forget {
  color: #333;
  text-align: right;
}

.cell-p {
  color: #000;
}

.self_b {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/view/update_password.vue